module.exports = __webpack_public_path__ + "media/images/pink-left-quote-ae4475ed36fbcc150493deb78135c975.svg";